/**
 * Empty State Component for Equipment Register
 * Shows when no user selections have been saved yet
 */

import React from 'react';
import { Package, Settings, ArrowRight } from 'lucide-react';

const EquipmentRegisterEmptyState = ({ onConfigureEquipment }) => {
  return (
    <div className="text-center py-12 px-6">
      {/* Icon */}
      <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-gray-100 mb-6">
        <Package className="h-8 w-8 text-gray-400" />
      </div>
      
      {/* Header */}
      <h3 className="text-lg font-medium text-gray-900 mb-2">
        No Equipment Configured
      </h3>
      
      {/* Description */}
      <p className="text-gray-600 mb-6 max-w-md mx-auto">
        Configure your vessel's safety equipment using the Equipment Selection Tab first. 
        This ensures you have complete control over your equipment inventory.
      </p>
      
      {/* Workflow Steps */}
      <div className="flex items-center justify-center space-x-3 mb-8 text-sm text-gray-500">
        <div className="flex items-center">
          <Settings className="h-4 w-4 mr-1" />
          Configure
        </div>
        <ArrowRight className="h-4 w-4" />
        <div className="flex items-center">
          <Package className="h-4 w-4 mr-1" />
          Register
        </div>
      </div>
      
      {/* Action Button */}
      <button
        onClick={onConfigureEquipment}
        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-cyan-600 hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500 transition-colors duration-200"
      >
        <Settings className="h-4 w-4 mr-2" />
        Configure Equipment
      </button>
      
      {/* Info Note */}
      <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg text-left max-w-md mx-auto">
        <h4 className="text-sm font-medium text-blue-900 mb-1">
          Equipment Selection Workflow
        </h4>
        <p className="text-sm text-blue-700">
          The Equipment Selection Tab shows you all regulatory requirements for your vessel. 
          You can review, approve, and customize your equipment list before it appears in this register.
        </p>
      </div>
    </div>
  );
};

export default EquipmentRegisterEmptyState;